import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/cloudy.vue
var o = {
	name: "DtIconCloudy",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--cloudy"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Cloudy",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("path", {
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		d: "M7.163 4.015a4 4 0 0 0-3.319-.96 2.25 2.25 0 0 1 4.072.582.5.5 0 0 0 .48.363H9.5a1 1 0 0 1 1 1 .5.5 0 0 0 1 0 2 2 0 0 0-2-2h-.75a3.251 3.251 0 0 0-6.159.485A4 4 0 0 0 4.5 11h4.25a2.75 2.75 0 1 0 0-5.5h-.541a4 4 0 0 0-1.046-1.485Zm-2.138.031A3 3 0 1 0 4.5 10h4.25a1.75 1.75 0 1 0 0-3.5h-.895a.5.5 0 0 1-.48-.357 3 3 0 0 0-2.35-2.097Z",
		fill: "currentColor"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=cloudy.js.map